"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorsManifest = void 0;
// Phase 123 Plan 06 Task 2 — Browser-safe sub-path export.
//
// The barrel `@hookmyapp/observability` re-exports `init/node`, `trace/*`, and
// `logger/adapter` — all of which pull `@sentry/node` transitively. Importing
// the barrel into the frontend bundle leaks ~1MB of Node-only code (OpenTelemetry,
// node-core, async-hooks) through Vite's commonjs interop even though the
// frontend never calls those modules at runtime.
//
// This entry point exposes ONLY the pure data/types — AppError + 15 subclasses
// + severity mapping + manifest drift helper + raw manifest JSON. Zero runtime
// dependencies. Safe for any bundler (Vite, esbuild, Rollup) on any target
// (browser, Node, CLI).
//
// Consumption: `import { UserBlockingError, AppError, severityToLevel } from '@hookmyapp/observability/errors'`.
__exportStar(require("./base"), exports);
__exportStar(require("./sev1"), exports);
__exportStar(require("./sev2"), exports);
__exportStar(require("./sev3"), exports);
__exportStar(require("../manifest/assert"), exports);
var manifest_json_1 = require("./manifest.json");
Object.defineProperty(exports, "errorsManifest", { enumerable: true, get: function () { return __importDefault(manifest_json_1).default; } });
